var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DataTable',{ref:"smsDataTable",attrs:{"url":_vm.api.ACTIONS.SMS_CODES,"titles":_vm.titles,"fields-hidden-main":['id', 'updated_at'],"title":_vm.$t('priceRulesPage.smsCodes.pageTitle'),"enableEdit":false,"enableAdd":false,"enableDelete":false,"formatter":_vm.formatter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }